import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router/';
import store from './store/';
import 'element-ui/lib/theme-chalk/index.css';
import element from './plugins/element';
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import * as echarts from 'echarts';
import format from 'vue-text-format';
//弹窗提示组件
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';

//修改默认vuetify的css类
import './styles/vuetify-custom.css';
//默认表单样式，用于同一风格，如果不满足要求，个别页面可自定义
import './styles/form-simple-standard.css';

import './styles/smp.css';

import formCreate from '@form-create/element-ui'
import FcDesigner from '@form-create/designer'

import { drag } from './directives';
import Auth from './util/auth';
import component from "@/components/index";

import Print from './api/common/print'

Vue.use(Print)

Vue.config.productionTip = false;

new Vue({
	vuetify,
	router,
	store,
	render: h => h(App)
}).$mount('#app');

//弹窗组件,按钮汉化
Vue.use(VuetifyDialog, {
	context: {
		vuetify
	},
	actions: {
		false: '取消',
		true: {
			text: '确定',
			color: 'primary'
		}
	},
	error: {
		actions: ['关闭']
	},
	info: {
		actions: ['确定']
	}
});

Vue.use(element)
Vue.use(preview)
Vue.use(format);
Vue.use(formCreate)
Vue.use(FcDesigner)

Vue.prototype.$echarts = echarts

component.registerComponent()
